module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04d-wire-shadow-sequence.7a723b40.png";